import React from 'react';
import './Brand.css';

function Brand({ image }) {
    if (!image) return null;

    return (
        <section className="brand">
            <div className="brand-logo">
                <img src={image} alt="logo" />
            </div>
        </section>
    );
}

export default Brand;
